import { createFileRoute } from "@tanstack/react-router";
import AmbetterInsurance, { config } from "@/pages/AmbetterInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/ambetter-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Ambetter TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Does Ambetter cover TMS, SAINT TMS, and SPRAVATO? Learn about prior auth, medical necessity, and free benefits verification in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Ambetter TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Does Ambetter cover TMS, SAINT TMS, and SPRAVATO? Learn about prior auth, medical necessity, and free benefits verification in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/ambetter-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/ambetter-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AmbetterInsurance />;
}
